/**
 * Fades content up as it scrolls into view.
 *
 * Content is visible by default. This script hides only what is still below the fold when it
 * runs, so nothing flashes and nothing stays hidden if the script never loads.
 */

const TARGETS = '[data-mod-reveal], #MainContent product-card';
const STAGGER_MS = 70;
const MAX_STAGGER_STEPS = 6;
const CLEANUP_MS = 900;

function init() {
  const observer = new IntersectionObserver(
    (entries) => {
      const entering = entries.filter((entry) => entry.isIntersecting);

      entering.forEach((entry, index) => {
        const element = /** @type {HTMLElement} */ (entry.target);
        const delay = Math.min(index, MAX_STAGGER_STEPS) * STAGGER_MS;

        observer.unobserve(element);
        element.style.setProperty('--mod-reveal-delay', `${delay}ms`);
        element.classList.add('mod-reveal--in');

        // Clear our classes afterwards so they never fight a component's own transforms.
        setTimeout(() => {
          element.classList.remove('mod-reveal', 'mod-reveal--in');
          element.style.removeProperty('--mod-reveal-delay');
        }, CLEANUP_MS + delay);
      });
    },
    { rootMargin: '0px 0px -8% 0px' }
  );

  for (const element of document.querySelectorAll(TARGETS)) {
    if (element.getBoundingClientRect().top < window.innerHeight) continue;

    element.classList.add('mod-reveal');
    observer.observe(element);
  }
}

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

if (!reducedMotion && !window.Shopify?.designMode && 'IntersectionObserver' in window) {
  init();
}
